import './Component.scss';

import React from 'react';

function Component({ title, place, company, date, city, info }) {
  if (Array.isArray(info)) {
    return (
      <div className='component'>
        <div className='component-left'>
          <h4 className='component-title'>{title}</h4>
          <div className='component-company'>{company}</div>
          <div className='component-date'>{date}</div>
          <div className='component-city'>{city}</div>
        </div>
        <div className='component-right'>
          <ul className='component-bullets'>
            {info.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    );
  }

  return (
    <div className='component component--single'>
      <h4 className='component-title'>{title}</h4>
      <div className='component-place'>{place}</div>
      <div className='component-info'>{info}</div>
      <div className='component-city'>{city}</div>
      <div className='component-date'>{date}</div>
    </div>
  );
}

export default Component;
